export const fakeFacetCallEN = {
  data: {
    category: {
      id: 17,
      parentCategoryId: 16,
      level: 2,
      type: 'item',
      linklist: 'Y',
      right: 'all',
      sitemap: 'Y',
      details: [
        {
          categoryId: '17',
          lang: 'de',
          name: 'Sessel & Hocker',
          description: '',
          description2: '',
          shortDescription: '',
          metaKeywords: 'moebel, sessel, hocker, wohnzimmer',
          metaDescription: '',
          nameUrl: 'sessel-hocker',
          metaTitle: '',
          position: '5',
          itemListView: 'ItemViewCategoriesList',
          singleItemView: 'ItemViewSingleItem',
          pageView: 'PageDesignContent',
          fulltext: 'N',
          metaRobots: 'ALL',
          canonicalLink: '',
          updatedAt: '2021-11-16T08:28:25+01:00',
          updatedBy: 'Plentymarkets Support',
          plenty_category_details_image_path: '',
          plenty_category_details_image2_path: '',
          image: null,
          imagePath: null,
          image2: null,
          image2Path: null,
          plentyId: 60796,
        },
      ],
      clients: [
        {
          categoryId: '17',
          plentyId: 60796,
        },
      ],
    },
    products: [],
    facets: [
      {
        id: 'feedback',
        name: 'Feedback',
        position: 10,
        names: [
          {
            lang: 'de',
            name: 'Artikelbewertung',
          },
          {
            lang: 'en',
            name: 'Item rating',
          },
        ],
        values: [
          {
            id: 'feedback-2',
            names: [
              {
                lang: 'de',
                name: '',
              },
            ],
            count: 1,
            selected: 21,
          },
        ],
        minHitCount: 1,
        maxResultCount: 5,
        type: 'feedback',
        count: 1,
      },
      {
        id: 6,
        name: 'Example Customized Filter 1',
        cssClass: '',
        position: 1,
        sort: 'position',
        minHitCount: '1',
        maxResultCount: '50',
        count: 1,
        values: [
          {
            id: 19,
            name: 'Value 1',
            cssClass: '',
            position: 1,
            count: 1,
            selected: false,
          },
          {
            id: 20,
            name: 'Value 2',
            cssClass: '',
            position: 1,
            count: 1,
            selected: false,
          },
        ],
        type: 'dynamic',
      },
      {
        id: 1,
        name: 'Manufacturer',
        cssClass: '',
        position: 1,
        sort: 'position',
        minHitCount: '1',
        maxResultCount: '50',
        count: 18,
        values: [
          {
            id: 1,
            name: 'Exclusive Leather',
            cssClass: '',
            position: 1,
            count: 5,
            selected: false,
          },
          {
            id: 2,
            name: 'A & C Design',
            cssClass: '',
            position: 2,
            count: 13,
            selected: false,
          },
        ],
        type: 'producer',
      },
      {
        id: 2,
        name: 'Example Customized Filter 2',
        cssClass: '',
        position: 2,
        sort: 'position',
        minHitCount: '1',
        maxResultCount: '50',
        count: 17,
        values: [
          {
            id: 3,
            name: 'Value 1',
            cssClass: '',
            position: 1,
            count: 2,
            selected: false,
          },
          {
            id: 4,
            name: 'Value 2',
            cssClass: '',
            position: 2,
            count: 5,
            selected: false,
          },
          {
            id: 6,
            name: 'Value',
            cssClass: '',
            position: 4,
            count: 4,
            selected: false,
          },
        ],
        type: 'dynamic',
      },
      {
        id: 3,
        name: 'Price',
        cssClass: '',
        position: 3,
        sort: 'position',
        minHitCount: '1',
        maxResultCount: '50',
        count: 0,
        values: [],
        type: 'price',
      },
      {
        id: 5,
        name: 'Availability',
        cssClass: '',
        position: 4,
        sort: 'position',
        minHitCount: '1',
        maxResultCount: '50',
        count: 18,
        values: [
          {
            id: 14,
            name: 'Ready for immediate dispatch, delivery time 48h',
            cssClass: '',
            position: 1,
            count: 18,
            selected: false,
          },
        ],
        type: 'availability',
      },
    ],
    languageUrls: {
      'x-default': '/living-room/armchair-stool/',
      de: '/wohnzimmer/sessel-hocker/',
      en: '/living-room/armchair-stool/',
    },
    pagination: {
      perPageOptions: [20, 40, 100],
      totals: 8,
    },
  },
};
